import { getDayBeforeYesterday } from '../utils/DateHelper';

const metaDefaults = {
    error: null,
    date: new Date(),
    dayBeforeString: getDayBeforeYesterday(),
    pharmacyListingTitle: 'Other Pharmacies',
}

const metaReducer = (state = metaDefaults, action) => {
    switch(action.type) {
        case 'SET_PHARMACY_TITLE': {
            return { ...state, pharmacyListingTitle: action.payload }
        }
    }
    return state;
}

export default metaReducer;


// WEBPACK FOOTER //
// ./src/reducers/meta.js